
export const GET_JOCKEYRANKING = `
query rw_GetJockeyRanking($season: String) {
  jockeyStat(season: $season) {
    code
    name_ch
    name_en
    status
    id 
    isCurSsn
    season
    ssnStat { 
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      numStarts
      stakeWon
      trk
      ven
    } 
    dhStat {
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      numStarts
      stakeWon
      trk
      ven
    }
  }
}
`;

export const GET_TRAINERRANKING = `
query rw_GetTrainerRanking($season: String) {
  trainerStat(season: $season) {
    code
    name_ch
    name_en
    status 
    id
    isCurSsn
    season
    visitingIndex
    ssnStat {
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      numStarts
      stakeWon
      trk
      ven
    }
    dhStat {
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      numStarts
      stakeWon
      trk
      ven
    }
  }
}
`;

export const GET_CURRENT_SEASON_DATE = `
query rw_LastMeeting($venueCodes: [String!]) {
  lastMeeting(venueCodes: $venueCodes) {
    date
    season 
  }
}
`;

export const GET_PREVIOUS_SEASON_DATE = `
query rw_RacingSeasonPeriod($locSim: LocalSim) {
  racingSeasonPeriod(locSim: $locSim) {
    code
    endDate
    startDate 
  }
}
`;
 

export const GET_JOCKEYSRIDES = `
query rw_JockeysRides ($dates: [String!]) {
  commonMeetings(dates: $dates, venueCodes: ["ST", "HV"], active: true) {
    date
    venueCode 
    status
    races {
      no
      claCode
      distance
      status
      raceTrack {
        code
        description_ch
        description_en
      }
      runners {
        horse {
          code
          name_ch
          name_en
          id
        }
        jockey {
          name_en
          name_ch
          code
        }
        id
        no
        winOdds
        status
        trumpCard
      }
    }
    pmPools(oddsTypes: [WIN]) {
      status
      sellStatus 
      id 
      leg {
        number
        races
      }
      oddsNodes {
        oddsValue 
        combString
        hotFavourite
      }
    }
    changeHistories {
      type
      time
      raceNo
      runnerNo
      horseName_ch
      horseName_en
      jockeyName_ch
      jockeyName_en
      scratchHorseName_ch
      scratchHorseName_en
      handicapWeight
      scrResvIndicator
      horseCode
      dueToPromotion
    }
    isActive
  }
  jockeyStat {
    code
    name_en
    name_ch
    ssnStat {
      numStarts
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      ven
      trk
      dist
      stakeWon
    }
    dhStat {
      numStarts
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      ven
      trk
      dist
      stakeWon
    }
  }
}
`;

export const GET_TRAINERSENTRIES = `
query rw_TrainersEntries ($dates: [String!]) {
  commonMeetings(dates: $dates, venueCodes: ["ST", "HV"], active: true) {
    date
    venueCode
    status
    totalNumberOfRace   
    raNoPlCount
    races {
      no
      status
      claCode
      distance 
      raceTrack {
        code
        description_ch
        description_en
      }
      runners {
        horse {
          code
          name_ch
          name_en
          id
        }
        trainer {
          name_en
          name_ch
          code
        }
        trainerPreference
        id
        no
        winOdds
        status
        trumpCard
        priority
      }
    }
    pmPools(oddsTypes: [WIN]) {
      status
      sellStatus 
      id 
      leg {
        number
        races
      }
      oddsNodes {
        oddsValue 
        combString
        hotFavourite
      }
    }
    isActive
  }
  trainerStat {
    code
    name_en
    name_ch
    ssnStat {
      numStarts
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      ven
      trk
      dist
      stakeWon
    }
    dhStat {
      numStarts
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      ven
      trk
      dist
      stakeWon
    }
  }
}
`;

export const GET_TNCTRAINERSENTRIES = `
query rw_TNCTRAINERSENTRIES ($dates: [String!]) {
  commonMeetings(dates: $dates, venueCodes: ["ST", "HV"]) {
    date
    venueCode
    status
    raNoPlCount
    races {
      no
      status
      claCode
      distance 
      raceTrack {
        code
        description_ch
        description_en
      }
      runners {
        horse {
          id
          code
          name_ch
          name_en
        }
        trainer {
          id
          name_en
          name_ch
          code
        }
        trainerPreference
        id
        no
        winOdds
        status
        trumpCard
      }
    }
    pmPools(oddsTypes: [WIN]) {
      id
      status
      leg {
        number
        races
      }
      oddsNodes {
        combString
        oddsValue
      }
    }
    foPools(oddsTypes: TNC){
      includeRaces
      status
      lastUpdateTime
      otherSelNo
      resultSheet{
        result{
          refId
          selOdrNo
          accumulatedPoints
          raIncidents{
            raIncidentType
            raceNo
            horseId
            points
          }
        }
        selStr
        id
      }
      instNo
      oddsTypeDes {
        code
        chinese
        english
        mandarin
      }
      inplayUpTo
      selections {
        currentOdds
        currentOddsValue
        combId
        openOdds
        code
        name_ch
        name_en
        points
        scheduleRides
    
        order
        number
      }
      otherResultSheet{
        otherResult{
          refId
          orderNo
          raIncidents{
            raceNo
            horseId
            raIncidentType
            points
          }
          accumulatedPoints
        }
        selStr
        id
      }
      otherSelections {
        currentOdds
        currentOddsValue
        combId
        openOdds
        code
        name_ch
        name_en
        points
        scheduleRides
    
        order
        number
      }
    }
    isActive
    currentNumberOfRace
  }
  trainerStat {
    code
    name_en
    name_ch
    dhStat {
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      numStarts
      stakeWon 
    }
  }
}
`;
export const GET_JKCSCHEDULEDRIDES = ` 
query rw_JKCScheduledRides($dates: [String!], $active: Boolean){
  commonMeetings(dates: $dates, venueCodes: ["ST", "HV"], active: $active) {
    id
    date
    venueCode
    venueDes {
      english
      chinese
    }
    status
    totalNumberOfRace
    raNoPlCount
    races {
      no
      claCode
      distance
      status
      raceTrack {
        description_ch
        description_en
      }
      raceTrack2 {
        description_ch
        description_en
      }
      raceResults {
        status
      }
      runners {
        no
        standbyNo
        status
        jockey {
          name_ch
          name_en
          code
        }
        horse {
          name_ch
          name_en
          code
          id
        }
      }
    }
    foPools(oddsTypes: [JKC]) {
      status
      instNo
      includeRaces
      inplayUpTo
      otherSelNo
      oddsTypeDes {
        english
        chinese
      }
      selections {
        currentOdds
        combId
        currentOddsValue
      }
      resultSheet {
        result {
          raIncidents {
            points
            horseId
            raceNo
            raIncidentType
          }
          refId
          selOdrNo
          accumulatedPoints
        }
        selStr
      }
      otherResultSheet {
        otherResult {
          orderNo
          accumulatedPoints
          raIncidents {
            points
            raceNo
            horseId
            raIncidentType
          }
          refId 
        }
        selStr
      }  
    }
    pmPools(oddsTypes:[WIN]) {
      status
      leg {
        number
        races
      }
      oddsNodes {
        combString
        oddsValue
      }
    }
    changeHistories {
      type
      runnerNo
      raceNo
      horseCode
      scratchHorseId
      dueToPromotion
    }
  }

  jockeyStat {
    code
    name_en
    name_ch 
    dhStat {
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      numStarts
      stakeWon
      trk
      ven
    }
    ssnStat { 
      numFirst
      numSecond
      numThird
      numFourth
      numFifth
      numStarts
      stakeWon
      trk
      ven
    } 
  }
}
`; 


export const  GET_FOStageQuery = `
query rw_info($commonMeetingsId: String, $oddsTypes: [OddsType], $pmPoolsOddsTypes2: [OddsType], $dates: [String!]) {
  commonMeetings(id: $commonMeetingsId, venueCodes: ["ST", "HV"], dates: $dates) {
    id
    status
    foPools(oddsTypes: $oddsTypes) {
      oddsType
      status
      isConcluded
    }
    pmPools(oddsTypes: $pmPoolsOddsTypes2) {
      hasCombs
    }
  }
}`;

export const GET_SUMMARYQUERY = `
query rw_Summary ($dates: [String!]) {
  commonMeetings(dates: $dates, venueCodes: ["ST", "HV", "S1", "S2", "S3", "S4", "S5", "S6", "S7", "S8", "S9"]) {
    date
    venueCode
    startTime
    totalNumberOfRace

    pmPools(oddsTypes: [WIN,PLA,QIN,QPL,CWA,CWB,CWC,IWN,FCT,TCE,TRI,FF,QTT,DBL,TBL,DT,TT,SixUP]) {
      id
      jackpot
      leg {
        number
        races
      }
      dividends {
        winComb
        type
        seq
        partialUnit
        guarantee
        div
        partial
        status
      }
      oddsType
      hasCombs
      estimatedDividend
      comingleStatus
      rebateRate
      sellStatus
      mergedPoolId
      futureJackpot {
        venCode
        meetingDate
        meetingID
        firstLegRaceNo
        mergedBetType
        poolOrder
        includeResFund
        jackpot
      }
    }
    isActive
    jkSuspensions {
      commencedOn
      desc {
        code
        english
        chinese
      }
      jockeyId
      jockeyNms {
        chinese
        code
        english
      }
      resumedOn
      spsnTyp
    }
    foPools {
      oddsType
      oddsTypeDes {
        chinese
        english
      }
      instNo
    }
    stewards {
      name_ch
      name_en
      role {
        english
        chinese
        code
      }
      sequenceNumber
    }
    venueDes {
      chinese
      english
      code
    }
    country {
      namech
      nameen
      seq
    }
    penetrometerReadings {
      reading
      readingTime
    }
    hammerReadings {
      readingTime
      reading
    }
    meetingTrack_ch
    meetingTrack_en
    meetingType
    meetingTrackCode
    status
    isSeasonLastMeeting
    course {
      chinese
      code
      english
    }
    races {
      no
      raceCourse {
        code
        displayCode
        description_en
        description_ch
      }
      raceTrack {
        code
        description_en
        description_ch
      }
      go_ch
      go_en
      goCode
      venueCode
    }
  }
}
`;

export const GET_CHANGES = `
  query rw_ChangeHistories($dates: [String!], $active: Boolean){
    commonMeetings(dates: $dates, active: $active) {
      id
      date
      venueCode
      isActive
      status
      races {
        no 
        status 
      } 
      changeHistories {
        type
        time
        raceNo
        runnerNo
        horseName_ch
        horseName_en
        jockeyName_ch
        jockeyName_en
        scratchHorseName_ch
        scratchHorseName_en
        handicapWeight
        scrResvIndicator
        horseCode
        saddleClothNo
      }
      venueDes {
        english
        chinese
      }
      country {
        namech
        code
        nameen
        seq
      }
    }
  }
`;

export const GET_HORSE_FORMER_NAME = `
  query rw_HorseFormerName {
    horses {
      id
      code
      name_en
      name_ch
      formerName
      sire
      dam
      importType
      importTypeNm {
        english
        chinese
        code
      }
      cntyOfOrg {
        code
        chinese
        english
      }
      age
      foalingDate
    }
  }
`; 

export const GET_TIMEOFFSET = `
query TimeOffset {
  timeOffset {
    ts
    fb
    rc
    m6
  }
}
`;